import type { SpreadTemplate } from "../types";
import { BASE_SPREAD_TEMPLATES } from "./base";

// English comment: A4 portrait spread templates (mapped from base list)
export const SPREADS_A4_PORTRAIT: SpreadTemplate[] = BASE_SPREAD_TEMPLATES.map((b) => ({
  id: `a4p_${b.idSuffix}`,
  name: b.name,
  format_group: "a4_portrait",
  unitKind: "spread",
  blocks: b.blocks
}));
